<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :loading="loading"
      :columns="tableColumns"
      size="mini"
      :height="200"
      border
      :checkbox-config="{
        highlight: true,
      }"
      :header-cell-style="
        () => {
          return {
            backgroundColor: '#bd94c1',
            color: '#ffffff',
          }
        }
      "
    >
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
    }
  },
}
</script>
